import Vue from 'vue'
import VueRouter from 'vue-router'
import { setToken, getToken } from "@/utils/token";
// import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    path: '/task',
    name: 'performtask',
    component: () => import(/* webpackChunkName: "performtask" */ '@/views/PerformTask.vue')
  },
  {
    path: '/looktask',
    name: 'looktask',

    component: () => import(/* webpackChunkName: "looktask" */ '@/views/LookTask.vue')
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import(/* webpackChunkName: "signin" */ '@/views/SignIn.vue')
  },
  {
    path: '/gridlist',
    name: 'gridlist',
    component: () => import(/* webpackChunkName: "gridlist" */ '@/views/Gridlist.vue')
  },
  {
    path: '/problemlist',
    name: 'problemlist',
    component: () => import(/* webpackChunkName: "problemlist" */ '@/views/Problemlist.vue')
  },
  {
    path: '/problemEscalation',
    name: 'problemEscalation',
    component: () => import(/* webpackChunkName: "problemEscalation" */ '@/views/ProblemEscalation.vue'),

  },
  {
    path: '/collectionForm',
    name: 'collectionForm',
    component: () => import('@/views/collectionForm.vue'),
  },
  {
    path: '/problemwwz',
    name: 'problemwwz',
    component: () => import(/* webpackChunkName: "problemwwz" */ '@/views/Problemwwz.vue'),

  },
  // {
  //   path: '/ddlogin',
  //   name: 'ddlogin',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "signin" */ '@/views/dd-login.vue'),

  // },
  {
    path: '/integral',
    name: 'integral',
    component: () => import(/* webpackChunkName: "integral" */ '@/views/integral.vue'),

  }, {
    path: '/transfer',
    name: 'transfer',
    component: () => import(/* webpackChunkName: "transfer" */ '@/views/Transfer.vue'),
  }, {
    path: '/perall',
    name: 'perall',
    component: () => import(/* webpackChunkName: "perall" */ '@/views/personnelAllotment.vue'),
  }, {
    path: '/peacetime',
    name: 'peacetime',

    component: () => import('@/views/Peacetime.vue'),
  }, {
    path: '/zlogin',
    name: 'zlogin',
    component: () => import('@/views/zzd-login.vue'),
  }, {
    path: '/dlogin',
    name: 'dlogin',
    component: () => import('@/views/dd-login.vue'),
  }
]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach((to, from) => {
  to.meta.page_id = Math.random().toString(36) // 使用Math.random生成随机字符串作为唯一ID
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-waiting', 'MAN']
  });
  aplus_queue.push({
    'action': 'aplus.sendPV',
    'arguments': [{
      is_auto: false
    }, {
      sapp_id: '35084',
      sapp_name: 'blzxzzdyzh',
      page_id: to.meta.page_id ? to.meta.page_id : 1,
      page_name: to.name,
      page_url: window.location.href
    }]
  })
  // 用户信息埋点
  //如采集用户信息是异步行为需要先执行这个BLOCK埋点
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_hold', 'BLOCK']
  });
  // 设置会员昵称
  aplus_queue.push({
    action: "aplus.setMetaInfo",
    arguments: ["_user_nick", getToken("gridName")],
  });
  // 设置会员 ID
  aplus_queue.push({
    action: "aplus.setMetaInfo",
    arguments: ["_user_id", getToken("gridPhone")],
  });
  // 如采集用户信息是异步行为，需要先设置完用户信息后再执行这个START埋点
  // 此时被block住的日志会携带上用户信息逐条发出
  aplus_queue.push({
    action: "aplus.setMetaInfo",
    arguments: ["_hold", "START"],
  });
});
export default router
